import * as React from "react";
import { Typography, Button } from "antd";
import SelectInput from "../app/SelectInput";
import { IReportingPeriodItem } from "../../../model/report/ReportingPeriodItem";
import { IRiskCriteriaPresentationModel } from "../../../presenter/report/Report4Presenter";
import { TTranslate } from "../../../service/locale/TranslationService";
import MultiSelect from "../app/MultiSelect";

export interface State {}
export interface Props {
  currentReportingPeriod?: IReportingPeriodItem;
  reportingPeriodList: IReportingPeriodItem[];
  onChangeReportingPeriod(reportingPeriodId: number): void;
  riskCriteria: IRiskCriteriaPresentationModel[];
  getPDFReport: any;
  translate: TTranslate;
  loading?: boolean;
  title?: string;
  onRiskCriteriaChange: (values: any[]) => void;
  selectedRiskCriteriaIds: number[];
}

export default class Report4ParamBox extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { ...props, selectedRiskCriteria: [] };
  }
  render() {
    const {
      currentReportingPeriod,
      reportingPeriodList,
      onChangeReportingPeriod,
      riskCriteria,
      getPDFReport,
      translate,
      loading,
      title,
      onRiskCriteriaChange,
      selectedRiskCriteriaIds
    } = this.props;
    return (
      <div className={"report-sidebar"}>
        <div className={"report-param-title "}>
          <Typography.Title style={{ fontSize: 14 }}>{title}</Typography.Title>
          <SelectInput
            value={currentReportingPeriod?.id.toString()}
            placeholder={translate("reports.params.placeholder")}
            selectOptions={reportingPeriodList}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            style={{ width: "100%" }}
            onChange={(e) => {
              onChangeReportingPeriod(parseInt(e, 10));
            }}
            defaultActiveFirstOption={false}
            showSearch={true}
            notFoundContent={translate("search.no_data")}
          />
          <div style={{ marginTop: 20 }}>
            <Typography.Title style={{ fontSize: 14 }}>
              {translate("report4.risk_criteria")}
            </Typography.Title>
            <MultiSelect
              mode={"multiple"}
              options={riskCriteria}
              selectOptionKey={"id"}
              selectOptionValue={"name"}
              onChange={onRiskCriteriaChange}
              placeholder={translate("report4.choose_risk_criteria")}
              value={selectedRiskCriteriaIds}
              style={{ width: "100%" }}
              notFoundContent={translate("search.no_data")}
            />
          </div>
        </div>

        <Button
          className={"report-btn"}
          type="primary"
          onClick={() => getPDFReport()}
          loading={loading || false}
          disabled={currentReportingPeriod ? false : true}
        >
          {translate("reports.show")}
        </Button>
      </div>
    );
  }
}
